import React, { ElementType, HTMLAttributes, useEffect, useRef } from 'react'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import ThemeInterface from '@/theme-interface'

interface Props extends HTMLAttributes<HTMLElement> {
  as?: ElementType
  className?: string
  children: string
}

const useStyles = makeStyles<ThemeInterface, Props>((theme) => ({
  container: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: 'calc(100%)',
    display: 'inline-block',
  },
}))

function TextEllipsis(props:Props) {
  const classes = useStyles(props)
  const { as: Tag = 'div', className, children, ...otherProps } = props
  const elementRef = useRef<HTMLElement>()

  useEffect(() => {
    // requestAnimationFrame ensures the check runs after layout is complete
    const frameId = requestAnimationFrame(() => {
      if (elementRef.current) {
        if (elementRef.current.offsetWidth < elementRef.current.scrollWidth) {
          elementRef.current.setAttribute('title', children)
        } else {
          elementRef.current.removeAttribute('title')
        }
      }
    })
    return () => cancelAnimationFrame(frameId)
  }, [children])

  return (
    <Tag ref={elementRef} className={clsx(className, classes.container)} {...otherProps}>
      {children}
    </Tag>
  )
}

export default TextEllipsis
